export default __webpack_public_path__ + "static/media/GRAPHIC.6324fb6b.svg";